module.exports = __webpack_public_path__ + "img/ico-world.08b63cb3.png";